export interface ICounselor {
    id: number,
    firstName: string,
    lastName: string,
    ildaCaseLoad: number,
    activeCaseCount: number
}